// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main Container */

.outer-container-dispaly {
  /* border: 1px solid rgb(202, 202, 202); */
  /* width: 1400px; */
  border-radius: 13px;
  /* height: 70vh; */
}
.heading-display {
  /* border: 1px solid black; */
  margin: 5px;
  height: 50px;
  background-color: rgb(230 240 230 / 58%);
}
.heading-display h3 {
  /* border: 1px solid black; */
  padding: 12px;
}
.tracker-details-container {
  display: flex;
  gap: 5px;
  /* border: 1px solid black; */
}
.tracker-data {
  position: relative;
  height: 310px;
  width: 265px;
  /* border: 2px solid black; */
  /* margin: 20px; */
  /* text-align: center; */
}
.tracker-data li {
  /* background-color: #4caf97; */
  display: flex;
  font-size: small;
  margin: 11px;
  height: 26px;
  width: 200px;
  margin-left: 15px;
}
.lable-details {
  font-size: 14px;
  margin-left: 16px;
  margin-top: 5px;
}
/* input[type="radio"] {
  accent-color: rgb(214, 25, 25);
} */

.border-red-500 {
  accent-color: rgb(214, 25, 25);
}
.border-gray-400 {
  accent-color: gray;
}
.border-green-500 {
  accent-color: rgb(66, 152, 66);
}
.input-radio {
  /* position: absolute; */
  width: 7%;
  position: relative;
  z-index: 2; /* Keeps the checkbox above the line */
}
p,
label {
  font: 1rem "Fira Sans", sans-serif;
}

/* input {
  margin: 0.4rem;
} */

.input-radio::after {
  content: "";
  position: absolute;
  width: 1px;
  height: 32px;
  background: #dedede;
  /* top: 7%; */
  top: 23px;
  left: 6px;
  /* margin-left: 5px; */

  z-index: 1;
}
/* Remove the line for the last checkbox */
li:last-child .input-radio::after {
  display: none;
}

.display-details-container {
  padding: 20px;
  /* border: 1px solid rgb(189, 188, 188); */
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(
    to bottom,
    rgba(193, 223, 196, 0) 0%,
    rgba(222, 236, 221, 0.9647) 100%
  );
  border-radius: 25px;
  width: 70%;
  /* max-width: 800px; */
  margin: 10px;
  height: 346px;
  /* border: 2px solid black; */
}

.tracker-details {
  /* border: 1px solid rgb(202, 196, 196); */
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  background: linear-gradient(
    to bottom,
    rgba(201, 222, 203, 0) 0%,
    rgba(222, 236, 221, 0.9647) 100%
  );
  width: 30%;
  height: 346px;
  border-radius: 25px;
  margin: 10px;
}
/* Header Section */
.details-header {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
}

.details-header h3 {
  font-size: 1.8rem;
  color: #555;
  text-align: center;
}
.ContainerOfButton {
  border: 2px solid black;
  height: 50px;
}

/* Form Section */
.details-form {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: space-between;
}

.details-form-row {
  width: 100%;
}

/* Input Group */
.details-input-group {
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: calc(50% - 10px); /* Adjust to fit two columns with spacing */
  display: flex;
  flex-direction: column;
  margin-top: -30px;
}

.details-input-group label {
  font-size: 0.9rem;
  color: #555;
  margin-bottom: 0px;
  position: relative;
  width: fit-content;
  background-color: transparent;
  padding: 1px 10px;
  /* border: 1.5px solid #80808087; */
  border-bottom: none;
  /* margin-left: 10px; */
  border-radius: 6px;
}

.details-input-group input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 1rem;
}

.details-input-group input:focus {
  border-color: #4caf97;
  outline: none;
}

/* Responsive Design */
@media (max-width: 768px) {
  .details-input-group {
    flex: 1 1 100%; /* Stack inputs vertically on smaller screens */
  }
}

/*  */
.user_lable {
  display: block;
}

/* Button Container */

.navigation-btn {
  /* border: 1px solid black; */
  float: right;
  width: 65%;

  display: flex;
  justify-content: center;
  /* gap: 250px; */
  margin-bottom: 10px;
}

.previous-button {
  /* background-color: #4caf97; */
  padding: 8px 12px;
  /* border: 1px solid rgb(200, 200, 200); */
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  color: #555;
  border-radius: 5px;
  width: auto;
  margin-top: -2px;
}

.next-button {
  /* background-color: #4caf97; */
  padding: 12px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  color: #555;
  border-radius: 5px;
  margin-left: 100px;
  width: 80px;
  margin-top: -2px;
}

.editSaveBtn {
  padding: 12px 17px;
  border-radius: 5px;
  position: relative;
  display: flex;
  left: 88%;
  top: -59px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
  color: #555;
}

/*  */
`, "",{"version":3,"sources":["webpack://./src/components/ComponentsCss/ProfileComponent/DisplayDetailsOfUser.css"],"names":[],"mappings":"AAAA,mBAAmB;;AAEnB;EACE,0CAA0C;EAC1C,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,wCAAwC;AAC1C;AACA;EACE,6BAA6B;EAC7B,aAAa;AACf;AACA;EACE,aAAa;EACb,QAAQ;EACR,6BAA6B;AAC/B;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,eAAe;AACjB;AACA;;GAEG;;AAEH;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,wBAAwB;EACxB,SAAS;EACT,kBAAkB;EAClB,UAAU,EAAE,sCAAsC;AACpD;AACA;;EAEE,kCAAkC;AACpC;;AAEA;;GAEG;;AAEH;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,SAAS;EACT,sBAAsB;;EAEtB,UAAU;AACZ;AACA,0CAA0C;AAC1C;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,sCAAsC;EACtC;;;;GAIC;EACD,mBAAmB;EACnB,UAAU;EACV,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC;;;;GAIC;EACD,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;AACA,mBAAmB;AACnB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,YAAY;AACd;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,YAA0B;EAA1B,cAA0B;EAA1B,4BAA0B,EAAE,2CAA2C;EACvE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;EACjB,mCAAmC;EACnC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA,sBAAsB;AACtB;EACE;IACE,cAAc,EAAE,+CAA+C;EACjE;AACF;;AAEA,KAAK;AACL;EACE,cAAc;AAChB;;AAEA,qBAAqB;;AAErB;EACE,6BAA6B;EAC7B,YAAY;EACZ,UAAU;;EAEV,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;EAC/B,iBAAiB;EACjB,0CAA0C;EAC1C,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,sCAAsC;EACtC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,UAAU;EACV,sCAAsC;EACtC,WAAW;AACb;;AAEA,KAAK","sourcesContent":["/* Main Container */\n\n.outer-container-dispaly {\n  /* border: 1px solid rgb(202, 202, 202); */\n  /* width: 1400px; */\n  border-radius: 13px;\n  /* height: 70vh; */\n}\n.heading-display {\n  /* border: 1px solid black; */\n  margin: 5px;\n  height: 50px;\n  background-color: rgb(230 240 230 / 58%);\n}\n.heading-display h3 {\n  /* border: 1px solid black; */\n  padding: 12px;\n}\n.tracker-details-container {\n  display: flex;\n  gap: 5px;\n  /* border: 1px solid black; */\n}\n.tracker-data {\n  position: relative;\n  height: 310px;\n  width: 265px;\n  /* border: 2px solid black; */\n  /* margin: 20px; */\n  /* text-align: center; */\n}\n.tracker-data li {\n  /* background-color: #4caf97; */\n  display: flex;\n  font-size: small;\n  margin: 11px;\n  height: 26px;\n  width: 200px;\n  margin-left: 15px;\n}\n.lable-details {\n  font-size: 14px;\n  margin-left: 16px;\n  margin-top: 5px;\n}\n/* input[type=\"radio\"] {\n  accent-color: rgb(214, 25, 25);\n} */\n\n.border-red-500 {\n  accent-color: rgb(214, 25, 25);\n}\n.border-gray-400 {\n  accent-color: gray;\n}\n.border-green-500 {\n  accent-color: rgb(66, 152, 66);\n}\n.input-radio {\n  /* position: absolute; */\n  width: 7%;\n  position: relative;\n  z-index: 2; /* Keeps the checkbox above the line */\n}\np,\nlabel {\n  font: 1rem \"Fira Sans\", sans-serif;\n}\n\n/* input {\n  margin: 0.4rem;\n} */\n\n.input-radio::after {\n  content: \"\";\n  position: absolute;\n  width: 1px;\n  height: 32px;\n  background: #dedede;\n  /* top: 7%; */\n  top: 23px;\n  left: 6px;\n  /* margin-left: 5px; */\n\n  z-index: 1;\n}\n/* Remove the line for the last checkbox */\nli:last-child .input-radio::after {\n  display: none;\n}\n\n.display-details-container {\n  padding: 20px;\n  /* border: 1px solid rgb(189, 188, 188); */\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(\n    to bottom,\n    rgba(193, 223, 196, 0) 0%,\n    rgba(222, 236, 221, 0.9647) 100%\n  );\n  border-radius: 25px;\n  width: 70%;\n  /* max-width: 800px; */\n  margin: 10px;\n  height: 346px;\n  /* border: 2px solid black; */\n}\n\n.tracker-details {\n  /* border: 1px solid rgb(202, 196, 196); */\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);\n  background: linear-gradient(\n    to bottom,\n    rgba(201, 222, 203, 0) 0%,\n    rgba(222, 236, 221, 0.9647) 100%\n  );\n  width: 30%;\n  height: 346px;\n  border-radius: 25px;\n  margin: 10px;\n}\n/* Header Section */\n.details-header {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.details-header h3 {\n  font-size: 1.8rem;\n  color: #555;\n  text-align: center;\n}\n.ContainerOfButton {\n  border: 2px solid black;\n  height: 50px;\n}\n\n/* Form Section */\n.details-form {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: space-between;\n}\n\n.details-form-row {\n  width: 100%;\n}\n\n/* Input Group */\n.details-input-group {\n  flex: 1 1 calc(50% - 10px); /* Adjust to fit two columns with spacing */\n  display: flex;\n  flex-direction: column;\n  margin-top: -30px;\n}\n\n.details-input-group label {\n  font-size: 0.9rem;\n  color: #555;\n  margin-bottom: 0px;\n  position: relative;\n  width: fit-content;\n  background-color: transparent;\n  padding: 1px 10px;\n  /* border: 1.5px solid #80808087; */\n  border-bottom: none;\n  /* margin-left: 10px; */\n  border-radius: 6px;\n}\n\n.details-input-group input {\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 1rem;\n}\n\n.details-input-group input:focus {\n  border-color: #4caf97;\n  outline: none;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n  .details-input-group {\n    flex: 1 1 100%; /* Stack inputs vertically on smaller screens */\n  }\n}\n\n/*  */\n.user_lable {\n  display: block;\n}\n\n/* Button Container */\n\n.navigation-btn {\n  /* border: 1px solid black; */\n  float: right;\n  width: 65%;\n\n  display: flex;\n  justify-content: center;\n  /* gap: 250px; */\n  margin-bottom: 10px;\n}\n\n.previous-button {\n  /* background-color: #4caf97; */\n  padding: 8px 12px;\n  /* border: 1px solid rgb(200, 200, 200); */\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n  color: #555;\n  border-radius: 5px;\n  width: auto;\n  margin-top: -2px;\n}\n\n.next-button {\n  /* background-color: #4caf97; */\n  padding: 12px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n  color: #555;\n  border-radius: 5px;\n  margin-left: 100px;\n  width: 80px;\n  margin-top: -2px;\n}\n\n.editSaveBtn {\n  padding: 12px 17px;\n  border-radius: 5px;\n  position: relative;\n  display: flex;\n  left: 88%;\n  top: -59px;\n  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);\n  color: #555;\n}\n\n/*  */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
